import { motion } from "framer-motion";
import { ArrowRight, MapPin, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n";
import { IMAGES } from "../data";

const EASE = [0.22, 1, 0.36, 1];

const COPY = {
  it: {
    kicker: "Il team locale",
    title: "Persone vere, sul territorio. Non una piattaforma.",
    sub: "OGStay è coordinata da Enrico e da un team che vive l'Ogliastra tutto l'anno: chi ti accoglie conosce ogni casa e ogni spiaggia di persona.",
    cta: "Chi siamo",
  },
  en: {
    kicker: "The local team",
    title: "Real people, on the territory. Not a platform.",
    sub: "OGStay is coordinated by Enrico and a team who live in Ogliastra all year round: whoever welcomes you knows every home and every beach first-hand.",
    cta: "About us",
  },
};

export default function HomeTeam() {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const c = COPY[lang];
  return (
    <section id="team" data-testid="home-team" className="py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 34 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="overflow-hidden rounded-t-[10rem] rounded-b-[2rem] ring-1 ring-navy/10"
        >
          <img src={IMAGES.servicesAbout} alt={lang === "en" ? "The OGStay team in Ogliastra" : "Il team OGStay in Ogliastra"} loading="lazy" className="aspect-[4/5] w-full object-cover" />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 34 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
        >
          <p className="kicker text-navy">
            <span className="h-px w-10 bg-sky" />
            {c.kicker}
          </p>
          <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-navy sm:text-5xl">{c.title}</h2>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-mute sm:text-lg">{c.sub}</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <span className="inline-flex items-center gap-2 rounded-full bg-sand px-4 py-2 text-xs font-bold text-navy ring-1 ring-navy/10">
              <MapPin className="h-3.5 w-3.5 text-med" />
              Tortolì · Ogliastra
            </span>
            <span className="inline-flex items-center gap-2 rounded-full bg-sand px-4 py-2 text-xs font-bold text-navy ring-1 ring-navy/10">
              <Users className="h-3.5 w-3.5 text-med" />
              {lang === "en" ? "100% local team" : "Team 100% locale"}
            </span>
          </div>
          <button data-testid="home-team-cta" onClick={() => navigate("/chi-siamo")} className="btn-secondary mt-9">
            {c.cta}
            <ArrowRight className="h-4 w-4" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
